import { render, staticRenderFns } from "./Reminder.vue?vue&type=template&id=8b568adc&scoped=true"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"
import style0 from "./Reminder.vue?vue&type=style&index=0&id=8b568adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b568adc",
  null
  
)

export default component.exports